import React from 'react';

import Skeleton from 'react-loading-skeleton';

import { motion } from "framer-motion";

export default function ComponentCardCount(props) {
    return (
        <motion.div whileHover={{ scale: 1.05 }} className="col-span-2 cursor-pointer">
            {
                !props.loading && <div className={`shadow rounded-lg border-l-[6px] ${props.bg}`}>
                    <div className="box p-5">
                        <div className="">
                            <div className='text-xs'>{props.head}</div>
                            <div className='text-xl font-medium'>{props.count}</div>
                            <div className='text-sm'>-</div>
                            <div className='text-sm text-gray-600'>{props.disc}</div>
                        </div>
                    </div>
                </div>
            }
            {props.loading && <Skeleton className='h-[100px]' />}
        </motion.div>
    )
}
